module.exports = __webpack_public_path__ + "static/media/about.1a4f7e84.png";